import CertsFooterActionBar from './CertsFooterActionBar';

export default CertsFooterActionBar;
